import { gql } from "@apollo/client";

// A published version: the definition as it was frozen, and when. Read-only —
// there is no mutation on a version, only `publish` on the workflow.
export const WorkflowVersionFragment = gql`
  fragment WorkflowVersionFragment on WorkflowVersion {
    id
    workflowId
    version
    title
    description
    steps
    subforms
    publishedAt
  }
`;

// Beneath the workflow, which is the partition: there is no way to name a
// version without first naming the workflow it is a version of. Newest first.
export const list = gql`
  query WorkflowVersionList($workflowId: String!, $input: ListInput) {
    viewer {
      id
      account {
        id
        workflows {
          id
          get(workflowId: $workflowId) {
            id
            versions {
              id
              list(input: $input) {
                id
                last
                items {
                  ...WorkflowVersionFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${WorkflowVersionFragment}
`;

// Every version the workflow has, walked to the end. Through the client on
// demand rather than a hook, the way the responses export walks captures:
// the tabs that need the whole set (Responses, to read each answer against
// the version it was given to; the export) ask once and keep the map.
export const fetchAll = async (client, workflowId, { fetchPolicy = "cache-first" } = {}) => {
  const versions = [];
  let last = null;

  do {
    const { data } = await client.query({
      query: list,
      variables: { workflowId, input: { last, limit: 100 } },
      fetchPolicy,
    });
    const page = data.viewer.account.workflows.get.versions.list;
    versions.push(...page.items);
    last = page.last || null;
  } while (last);

  return versions;
};
